export default "__VITE_ASSET__B3faAITC__"